import React from 'react';

import GameFormContainer from '@/components/GameFormContainer';
import { GameProps } from '@/components/Gameinterfaces';

interface GameStepSubmitProps extends GameProps {
  [key: string]: any;
}

const GameStepSubmit: React.FC<React.PropsWithChildren<GameStepSubmitProps>> = (
  props
) => {
  return (
    <div className="">
      <GameFormContainer
        {...props}
        onClickBackButton={props.onClickBackButton}
      />
    </div>
  );
};

export default GameStepSubmit;
